import PlatformIndex, { getServerSideProps } from '@/components/PlatformIndex/index';
import { withUrql } from '@/lib/urqlClient';

export { getServerSideProps };
export default withUrql(PlatformIndex);
